<template>
  <div
    v-if="honeypot.enabled"
    :name="`${honeypot.nameFieldName}_wrap`"
    style="display: none;"
    aria-hidden="true"
  >
    <input
      type="text"
      v-model="modelValue[honeypot.nameFieldName]"
      :name="honeypot.nameFieldName"
      :id="honeypot.nameFieldName"
      tabindex="-1"
      autocomplete="off"
    />
    <input
      type="text"
      v-model="modelValue[honeypot.validFromFieldName]"
      :name="honeypot.validFromFieldName"
      tabindex="-1"
      autocomplete="off"
    />
  </div>
</template>

<script setup>
import { usePage } from '@inertiajs/vue3'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
})

const honeypot = usePage().props.honeypot
</script>
